<template>
    <div class="double-cta-section">
        <b-container>
            <mobile-gutter>
                <b-row class="cta-row">
                    <fade-up-animation
                        v-for="(item, i) in items"
                        :key="item.title"
                        :element="() => $refs[item.title]"
                        :y-from="(10 * i) + 50"
                    >
                        <b-col
                            cols="12"
                            md="6"
                            class="cta-column"
                            :ref="item.title"
                        >
                            <call-to-action
                                v-bind="item"
                            />
                        </b-col>
                    </fade-up-animation>
                </b-row>
            </mobile-gutter>
        </b-container>
    </div>
</template>

<script>
    import CallToAction from '../../molecules/CallToAction/CallToAction';

    export default {
        name: 'double-cta-section',

        components: { CallToAction },

        props: {
            items: {
                type: Array,
                default: () => ([]),
            },
        },
    };
</script>

<style lang="scss" scoped>
    .double-cta-section {
        padding: 40px 0;
        position: relative;

        @include media-breakpoint-up(md) {
            &:after {
                content: '';
                border-right: solid 1px secondary-palette(7);
                position: absolute;
                top: 30px;
                left: 50%;
                bottom: 30px;
            }
        }
    }

    .cta-column {
        &:first-of-type {
            .call-to-action {
                @include media-breakpoint-up(md) {
                    padding-right: 40px;
                }

                @include media-breakpoint-up(lg) {
                    padding-right: 55px;
                }

                @include media-breakpoint-up(xl) {
                    padding-right: 100px;
                }

                &:after {
                    content: '';
                    width: 90%;
                    border-bottom: solid 1px secondary-palette(6);
                    margin-bottom: 35px;
                    padding-bottom: 30px;

                    @include media-breakpoint-up(md) {
                        border-bottom: none;
                        margin-bottom: 0;
                        padding-bottom: 0;
                    }
                }
            }
        }

        &:last-of-type {
            .call-to-action {
                @include media-breakpoint-up(md) {
                    padding-left: 40px;
                }

                @include media-breakpoint-up(lg) {
                    padding-left: 55px;
                }

                @include media-breakpoint-up(xl) {
                    padding-left: 100px;
                }
            }
        }
    }
</style>
